// SVG Icon exports - these will be transformed by react-native-svg-transformer
import IcApple from './ic-apple.svg';
import IcAroundthegreen from './ic-aroundthegreen.svg';
import IcArrowRight from './ic-arrow-right.svg';
import IcArrowUp from './ic-arrow-up.svg';
import IcAtg from './ic-atg.svg';
import IcAttempts from './ic-attempts.svg';
import IcAward from './ic-award.svg';
import IcBackBlue from './ic-back-blue.svg';
import IcBack from './ic-back.svg';
import IcBook from './ic-book.svg';
import IcCalendar1 from './ic-calendar-1.svg';
import IcCalendar2 from './ic-calendar-2.svg';
import IcCalendarFill from './ic-calendar-fill.svg';
import IcCalendar from './ic-calendar.svg';
import IcCall from './ic-call.svg';
import IcCamera from './ic-camera.svg';
import IcCheckYourInbox from './ic-check-box.svg';
import IcCheckCircleOutline from './ic-check-circle-outline.svg';
import IcCheckListMd from './ic-check-list.svg';
import IcCheckMd from './ic-check-md.svg';
import IcCheck from './ic-check.svg';
import IcCheckboxChecked from './ic-checked.svg';
import IcCheckList from './ic-checklist.svg';
import IcCheckmarkBadge from './ic-checkmark-badge.svg';
import IcChevronRight from './ic-chevron-right.svg';
import IcClear from './ic-clear.svg';
import IcClockFill from './ic-clock-fill.svg';
import IcClock from './ic-clock.svg';
import IcClose from './ic-close.svg';
import IcCompletedFill from './ic-completed-fill.svg';
import IcCompleted from './ic-completed.svg';
import IcDelete from './ic-delete.svg';
import IcDirect from './ic-direct.svg';
import IcEdit2 from './ic-edit-2.svg';
import IcEditAvatar from './ic-edit-avatar.svg';
import IcEdit from './ic-edit.svg';
import IcEnvelope from './ic-envelope.svg';
import IcEye1 from './ic-eye-1.svg';
import IcEyeOff from './ic-eye-off.svg';
import IcEyeSlash from './ic-eye-slash.svg';
import IcEye from './ic-eye.svg';
import IcFaceId from './ic-face-id.svg';
import IcFacebook from './ic-facebook.svg';
import IcFilter from './ic-filter.svg';
import IcFingerPrint from './ic-fingerprint-scan.svg';
import IcForm from './ic-form.svg';
import { default as IcFullSwing, default as IcFullswing } from './ic-fullswing.svg';
import IcGoogle from './ic-google.svg';
import IcGpsSlash from './ic-gps-slash.svg';
import IcGuest from './ic-guest.svg';
import IcHome1Active from './ic-home-1-active.svg';
import IcHome1 from './ic-home-1.svg';
import IcHome from './ic-home.svg';
import IcInfo from './ic-info.svg';
import IcKidsActive from './ic-kids-active.svg';
import IcKids from './ic-kids.svg';
import IcKitEmpty from './ic-kit-empty.svg';
import IcKnowledge from './ic-knowledge.svg';
import IcLeave from './ic-leave.svg';
import IcLessonsEmpty from './ic-lessons-empty.svg';
import IcLink from './ic-link.svg';
import IcListCheck from './ic-list-check.svg';
import IcList from './ic-list.svg';
import IcLocation1 from './ic-location-1.svg';
import IcLocationFill from './ic-location-fill.svg';
import IcLocationMap from './ic-location-map.svg';
import IcLocationOff from './ic-location-off.svg';
import IcLocationSlash from './ic-location-slash.svg';
import IcLocation from './ic-location.svg';
import IcLock from './ic-lock.svg';
import IcLogout from './ic-logout.svg';
import IcMailHeart from './ic-mail-heart.svg';
import IcMailLove01 from './ic-mail-love-01.svg';
import IcMail from './ic-mail.svg';
import IcMapSearch from './ic-map-search.svg';
import IcMap from './ic-map.svg';
import IcMastery from './ic-mastery.svg';
import IcMessageQuestion from './ic-message-question.svg';
import IcMessageSquareCheck from './ic-message-square-check.svg';
import IcMinusCircle from './ic-minus-circle.svg';
import IcMoreVertical from './ic-more-vertical.svg';
import IcMyLocation from './ic-my-location.svg';
import IcNote from './ic-note.svg';
import IcNotesEmpty from './ic-notes-empty.svg';
import IcNotification1 from './ic-notification-1.svg';
import IcNotificationAward from './ic-notification-award.svg';
import IcNotificationBing from './ic-notification-bing.svg';
import IcNotificationClass from './ic-notification-class.svg';
import IcNotificationEmptyBackground from './ic-notification-empty-background.svg';
import IcNotificationEmpty from './ic-notification-empty.svg';
import IcNotificationNote from './ic-notification-note.svg';
import IcNotificationPeople from './ic-notification-people.svg';
import IcNotificationSettings from './ic-notification-settings.svg';
import IcNotificationSettingsFill from './ic-notification-settings-fill.svg';
import IcNotificationTrash from './ic-notification-trash.svg';
import IcNotification from './ic-notification.svg';
import IcPackage from './ic-package.svg';
import IcPaginationArrow from './ic-pagination-arrow.svg';
import IcPasswordCheck from './ic-password-check.svg';
import IcPeople from './ic-people.svg';
import IcPin from './ic-pin.svg';
import IcPlayerChecked from './ic-player-checked.svg';
import IcPlayerIndexGuardian from './ic-player-index-guardian.svg';
import IcPlayerIndexNotes from './ic-player-index-notes.svg';
import IcPlayerIndexPackage from './ic-player-index-package.svg';
import IcPlayerIndexProgress from './ic-player-index-progress.svg';
import IcPlayerPathway from './ic-player-pathway.svg';
import IcPlayerUnchecked from './ic-player-uncheck.svg';
import IcPlusBold from './ic-plus-bold.svg';
import IcPlusPlain from './ic-plus-plain.svg';
import IcPlus from './ic-plus.svg';
import IcPrivacyLegal from './ic-privacy-legal.svg';
import IcProfileLogout from './ic-profile-logout.svg';
import IcProfileNotification from './ic-profile-notification.svg';
import IcPutting from './ic-putting.svg';
import IcRadioChecked from './ic-radio-checked.svg';
import IcRadioUnchecked from './ic-radio-unchecked.svg';
import IcRefresh from './ic-refresh.svg';
import IcReport from './ic-report.svg';
import IcScore from './ic-score.svg';
import IcSearch1 from './ic-search-1.svg';
import IcSearch from './ic-search.svg';
import IcSecurityUser from './ic-security-user.svg';
import IcSetting3 from './ic-setting-3.svg';
import IcShare from './ic-share.svg';
import IcShop from './ic-shop.svg';
import IcShoppingActive from './ic-shopping-active.svg';
import IcShopping from './ic-shopping.svg';
import IcSkill1 from './ic-skill1.svg';
import IcSkill2 from './ic-skill2.svg';
import IcSmsBold from './ic-sms-bold.svg';
import IcSms from './ic-sms.svg';
import IcSort from './ic-sort.svg';
import IcStarOutline from './ic-star-outline.svg';
import IcStar from './ic-star.svg';
import IcStar2 from './ic-start2.svg';
import IcStop from './ic-stop.svg';
import IcTarget from './ic-target.svg';
import IcText from './ic-text.svg';
import IcTrash from './ic-trash.svg';
import IcCheckboxUnchecked from './ic-unchecked.svg';
import IcUndo from './ic-undo.svg';
import IcUpload from './ic-upload.svg';
import IcUserAdd01 from './ic-user-add-01.svg';
import IcUserCheck from './ic-user-check.svg';
import IcUserOctagon from './ic-user-octagon.svg';
import IcUserSettingsActive from './ic-user-settings-active.svg';
import IcUserSettings from './ic-user-settings.svg';
import IcUserSquare from './ic-user-square.svg';
import IcUserTick from './ic-user-tick.svg';
import IcPlayer from './ic-user.svg';
import IcWarning from './ic-warning.svg';
import IcXCloseCircleFilled from './ic-x-circle-filled.svg';
import IcXClose from './ic-x-close.svg';

// Icon name mapping for the SvgIcon component
export const iconRegistry = {
  IcTarget,
  IcAttempts,
  IcDelete,
  IcScore,
  IcCheckList,
  IcListCheck,
  IcCheckListMd,
  IcClock,
  IcChecked: IcPlayerChecked,
  IcUnchecked: IcPlayerUnchecked,
  IcPlayerChecked,
  IcPlayerUnchecked,
  IcCompleted,
  IcTrash,
  IcPlus,
  IcCall,
  IcMail,
  IcEdit,
  IcEditAvatar,
  IcText,
  IcClose,
  IcBackBlue,
  IcSort,
  IcFilter,
  IcCheckboxChecked,
  IcCheckboxUnchecked,
  IcEnvelope,
  IcRadioChecked,
  IcRadioUnchecked,
  IcHome,
  IcPlayer,
  IcPlayerPathway,
  IcPrivacyLegal,
  IcProfileLogout,
  IcProfileNotification,
  IcMessageQuestion,
  IcMessageSquareCheck,
  IcLock,
  IcLocation,
  IcLocationOff,
  IcCheckmarkBadge,
  IcDirect,
  IcPaginationArrow,
  IcSearch,
  IcSetting3,
  IcBack,
  IcEye,
  IcEyeOff,
  IcCalendar,
  IcPackage,
  IcPlusPlain,
  IcStop,
  IcPutting,
  IcAtg,
  IcFullSwing,
  IcKnowledge,
  IcForm,
  IcSkill1,
  IcSkill2,
  IcCompletedFill,
  IcMastery,
  IcAroundthegreen,
  IcFullswing,
  IcCheck,
  IcClear,
  IcLink,
  IcRefresh,
  IcGoogle,
  IcApple,
  IcFacebook,
  IcPasswordCheck,
  IcSms,
  IcEye1,
  IcEyeSlash,
  IcCheckYourInbox,
  IcInfo,
  IcArrowRight,
  IcChevronRight,
  IcCamera,
  IcCheckCircleOutline,
  IcCheckMd,
  IcXClose,
  IcUserCheck,
  IcUserSquare,
  IcUserOctagon,
  IcSecurityUser,
  IcEdit2,
  IcPin,
  IcCalendar2,
  IcLocationSlash,
  IcGpsSlash,
  IcSearch1,
  IcLocation1,
  IcAward,
  IcFaceId,
  IcNote,
  IcNotification,
  IcNotificationAward,
  IcNotificationBing,
  IcMoreVertical,
  IcNotificationClass,
  IcNotificationEmpty,
  IcNotificationEmptyBackground,
  IcNotificationNote,
  IcNotificationPeople,
  IcNotificationSettings,
  IcNotificationSettingsFill,
  IcNotificationTrash,
  IcPeople,
  IcShop,
  IcArrowUp,
  IcUserAdd01,
  IcMailHeart,
  IcMailLove01,
  IcFingerPrint,
  IcLogout,
  IcXCloseCircleFilled,
  IcLocationMap,
  IcMyLocation,
  IcHome1Active,
  IcHome1,
  IcBook,
  IcShopping,
  IcKids,
  IcSmsBold,
  IcUserSettings,
  IcNotification1,
  IcMap,
  IcStar,
  IcStarOutline,
  IcShoppingActive,
  IcKidsActive,
  IcUserSettingsActive,
  IcPlayerIndexProgress,
  IcPlayerIndexNotes,
  IcPlayerIndexGuardian,
  IcPlayerIndexPackage,
  IcLessonsEmpty,
  IcKitEmpty,
  IcNotesEmpty,
  IcStar2,
  IcPlusBold,
  IcWarning,
  IcReport,
  IcUndo,
  IcUpload,
  IcShare,
  IcLeave,
  IcMinusCircle,
  IcCalendar1,
  IcList,
  IcMapSearch,
  IcLocationFill,
  IcGuest,
  IcClockFill,
  IcUserTick,
  IcCalendarFill,
} as const;

export type AvailableIconName = keyof typeof iconRegistry;
